import type { GetContractProductsOverviewsResponse } from '@weft/api-definition';
import { GetContractProductsOverviewsResponseSchema } from '@weft/api-definition';
import { validateNotEmptyObject } from '@weft/utils';
import type { QueryClient } from 'react-query';
import { useQuery } from 'react-query';
import { getPrivateApi } from '../../services/api';
import type { CustomUseQueryOptions } from './requests-types/custom-use-query-options';

export function useContractProductsOverviews(contractId: string, options?: CustomUseQueryOptions<GetContractProductsOverviewsResponse>) {
  const contractProductsOverviewsQuery = useQuery(['contract-products-overviews', contractId], async () => {
    return getContractProductsOverviews(contractId);
  }, { suspense: true, ...options });
  
  validateNotEmptyObject(contractProductsOverviewsQuery.data, 'contractProductsOverviewsQuery.data');

  return contractProductsOverviewsQuery;
}

export async function prefetchContractProductsOverviews(contractId: string, queryClient: QueryClient) {
  await queryClient.prefetchQuery(['contract-products-overviews', contractId], () => getContractProductsOverviews(contractId));
}

export async function getContractProductsOverviews(contractId: string) {
  const privateApi = getPrivateApi();
  const getContractProductsOverviewsResponse = await privateApi.getContractProductsOverviews({ contractId });

  return GetContractProductsOverviewsResponseSchema.parse(getContractProductsOverviewsResponse);
}